module.exports = __webpack_public_path__ + "img/logo.2673e999.svg";